import React, { useContext } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { ControlFlagDocIdvRequiredAndCompletedControlValues } from '@getethos/ethos-global-lib';
import { getIdentificationDocLinkEndPoint } from '../../common/api.endPoints';
import { FlexCol, FlexRow, TitleSmall } from '../../common/components/v2';
import { HttpService } from '../../common/http.service';
import { SnackbarContext } from '../layout/SnackbarContext';
import styles from './styles.module.scss';

export const IdentificationDocLink = ({
  applicationId,
  citizenshipDocumentType,
  policyId,
  controlValue,
}: {
  applicationId: number;
  citizenshipDocumentType: string[];
  policyId: number;
  controlValue: ControlFlagDocIdvRequiredAndCompletedControlValues;
}) => {
  const { openSnacks, setSnacks } = useContext(SnackbarContext);

  const fetchIdentificationDocLink = async () => {
    try {
      const data = await HttpService.getInstance().get(
        getIdentificationDocLinkEndPoint(applicationId, controlValue),
      );
      if (data && !data.error) {
        return data.parsedBody.identificationDocLink;
      } else {
        setSnacks([
          ...openSnacks,
          {
            id: uuidv4(),
            type: 'alert',
            message: `Unable to download Identification doc. Please try later.`,
          },
        ]);
        return null;
      }
    } catch (error) {
      setSnacks([
        ...openSnacks,
        {
          id: uuidv4(),
          type: 'alert',
          message: `Unable to download Identification doc. Please try later.`,
        },
      ]);
      return null;
    }
  };

  const onClick = async () => {
    const identificationDocLink = await fetchIdentificationDocLink();
    if (identificationDocLink) {
      window.open(identificationDocLink, '_blank');
    }
  };
  const documentType =
    Array.isArray(citizenshipDocumentType) &&
    citizenshipDocumentType.length > 0 &&
    citizenshipDocumentType[0]
      ? citizenshipDocumentType[0]
      : '';

  const controlTitleMap: { [key: string]: string } = {
    uw_control: 'Residency Document Verification',
    aml_control: 'Government ID Document',
  };

  const title = controlTitleMap[controlValue];
  const documentName =
    controlValue === 'aml_control'
      ? `GOV_ID_${documentType.toUpperCase()}-${policyId}.pdf`
      : `${documentType.toUpperCase()}-${policyId}.pdf`;

  return (
    <>
      <FlexRow className={styles.Title}>
        <TitleSmall>{title}</TitleSmall>
      </FlexRow>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          {'Files'}
        </FlexCol>
        <FlexCol lg={6} className={styles.TaskInfoCell}>
          <button type={'button'} className={styles.Document} onClick={onClick}>
            {documentName}
          </button>
        </FlexCol>
      </FlexRow>
    </>
  );
};
